<template>
    <div class="sidebar">
        <div class="logo">
            平台管理系统
        </div>
        <div class="menu">
            <el-menu ref="menu" :router="true" theme="none" @open="handleOpen" @close="handleClose" :default-active="activePath">
                <el-menu-item index="/admin/main/index">
                    <span class="home" slot="title">首页</span>
                </el-menu-item>
                <el-menu-item index="/admin/main/device/list">
                    <span class="coach" slot="title">设备管理</span>
                </el-menu-item>
                <el-menu-item index="/admin/main/category/list">
                    <span slot="title"><i class="el-icon-share"></i>设备名称管理</span>
                </el-menu-item>
                <el-menu-item index="/admin/main/dealer/list">
                    <span class="activity" slot="title">经销商管理</span>
                </el-menu-item>
                <el-menu-item index="/admin/main/order/list">
                    <span class="course" slot="title">订单管理</span>
                </el-menu-item>
            </el-menu>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    handleOpen (key, keyPath) {},
    handleClose (key, keyPath) {}
  },
  computed: {
    activePath () {
      return this.$route.meta.activePath
        ? this.$route.meta.activePath
        : this.$route.path
    }
  }
}
</script>
<style scoped>
.sidebar>>>.el-menu-item:focus, .sidebar>>>.el-menu-item:hover{
  background:none ;
}
.sidebar {
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  overflow: hidden;
  background: #2b303b;
}

.logo {
  width: 100%;
  height: 80px;
  line-height: 80px;
  background: #272b35;
  color: #fff;
  text-align: left;
  font-size: 22px;
  text-indent: 20px;
}

.menu {
  position: absolute;
  width: 250px;
  overflow-y: scroll;
  top: 80px;
  bottom: 0px;
  padding-top: 20px;
}

.sidebar>>>.el-submenu__title,
.el-menu-item {
  color: #8892a2 !important;
}

.is-active,
.sidebar .is-active>>>.el-submenu__title {
  color: #fff !important;
}

.sidebar>>>.el-menu {
  background: none !important;
}

.sidebar>>>.el-submenu__title:hover,
.el-menu-item:hover {
  background: none !important;
  color: #fff !important;
}
</style>
<style scoped>
.menu .home {
  background: url(../../assets/icons/home.png) left center no-repeat;
  padding: 5px 5px 5px 30px;
}

.menu .is-active .home,
.menu .el-menu-item:hover .home {
  background-image: url(../../assets/icons/home_f.png);
}

.menu .coach {
  background: url(../../assets/icons/coach.png) left center no-repeat;
  padding: 5px 5px 5px 30px;
}

.menu .is-active .coach,
.menu .el-menu-item:hover .coach {
  background-image: url(../../assets/icons/coach_f.png);
}

.menu .course {
  background: url(../../assets/icons/course.png) left center no-repeat;
  padding: 5px 5px 5px 30px;
}

.menu .is-active .course,
.menu>>>.el-menu-item:hover .course {
  background-image: url(../../assets/icons/course_f.png);
}

.menu .activity {
  background: url(../../assets/icons/activity.png) left center no-repeat;
  padding: 5px 5px 5px 30px;
}

.menu .is-active .activity,
.menu .el-menu-item:hover .activity {
  background-image: url(../../assets/icons/activity_f.png);
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?3b035174